import React, { useEffect, useState } from 'react';
import api from '../../services/api';
import { locomotorasService } from '../../services/api';

const DIAS = [
  { num: '1', label: 'L' }, { num: '2', label: 'M' }, { num: '3', label: 'X' },
  { num: '4', label: 'J' }, { num: '5', label: 'V' }, { num: '6', label: 'S' }, { num: '7', label: 'D' },
];

function BadgeDias({ dias }) {
  return (
    <div style={{ display: 'flex', gap: 3 }}>
      {DIAS.map(d => (
        <span key={d.num} style={{
          width: 20, height: 20, borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center',
          fontSize: 10, fontWeight: 600,
          background: dias?.includes(d.num) ? '#1a1a1a' : '#f0f0f0',
          color: dias?.includes(d.num) ? '#fff' : '#aaa'
        }}>{d.label}</span>
      ))}
    </div>
  );
}

function NuevoServicioForm({ onGuardar, onCancelar, locomotoras }) {
  const [codigo, setCodigo] = useState('');
  const [lote, setLote] = useState('lote2');
  const [proyecto, setProyecto] = useState('exploradoras');
  const [dias, setDias] = useState('12345');
  const [locomotoraId, setLocomotoreId] = useState('');
  const [trenes, setTrenes] = useState([]);
  const [nuevoTren, setNuevoTren] = useState('');
  const [cargandoTren, setCargandoTren] = useState(false);
  const [error, setError] = useState(null);
  const [guardando, setGuardando] = useState(false);

  const toggleDia = (dia) => {
    setDias(prev => prev.includes(dia)
      ? prev.replace(dia, '')
      : (prev + dia).split('').sort().join('')
    );
  };

  const formatHora = (h) => {
    if (!h) return null;
    h = String(h).replace('.0', '').replace('.5', '').replace('.3', '').replace('.4', '');
    h = h.padStart(4, '0');
    return `${h.slice(0, 2)}:${h.slice(2)}`;
  };

  const añadirTren = async () => {
    if (!nuevoTren.trim()) return;
    setCargandoTren(true);
    setError(null);
    try {
      const r = await api.get(`/siges/tren-teorico/${nuevoTren.trim()}`);
      const d = r.data;
      setTrenes(prev => [...prev, {
        numero_tren: d.numero_tren,
        hora_inicio: formatHora(d.hora_inicio),
        estacion_inicio: d.estacion_inicio,
        cod_estacion_inicio: d.cod_estacion_inicio,
        hora_fin: formatHora(d.hora_fin),
        estacion_fin: d.estacion_fin,
        cod_estacion_fin: d.cod_estacion_fin,
        km_aproximados: null,
        orden: trenes.length + 1
      }]);
      setNuevoTren('');
    } catch (e) {
      setError(`No se encontraron datos para el tren ${nuevoTren} — verifica que el proxy está activo`);
    } finally {
      setCargandoTren(false);
    }
  };

  const eliminarTren = (i) => setTrenes(prev => prev.filter((_, idx) => idx !== i));

  const guardar = async () => {
    if (!codigo || trenes.length === 0) return;
    setGuardando(true);
    try {
      await api.post('/servicios-predefinidos/', {
        codigo, lote: proyecto === 'exploradoras' ? lote : null, proyecto, dias_semana: dias,
        locomotora_id: locomotoraId ? parseInt(locomotoraId) : null,
        trenes: trenes.map((t, i) => ({ ...t, orden: i + 1 }))
      });
      onGuardar();
    } catch (e) {
      setError('Error al guardar el servicio');
    } finally {
      setGuardando(false);
    }
  };

  return (
    <div style={{ background: '#fff', borderRadius: 12, border: '1px solid #e5e5e5', padding: 20, marginBottom: 20 }}>
      <h3 style={{ margin: '0 0 16px', fontSize: 16, fontWeight: 600 }}>Nuevo servicio predefinido</h3>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 12, marginBottom: 16 }}>
        <div>
          <label style={{ display: 'block', fontSize: 12, color: '#555', marginBottom: 4 }}>Nombre clave</label>
          <input value={codigo} onChange={e => setCodigo(e.target.value)} placeholder="BLB-PZR-TRC-BLB"
            style={{ width: '100%', padding: '8px 10px', borderRadius: 8, border: '1px solid #ddd', fontSize: 13, boxSizing: 'border-box' }} />
        </div>
        <div>
          <label style={{ display: 'block', fontSize: 12, color: '#555', marginBottom: 4 }}>Proyecto</label>
          <select value={proyecto} onChange={e => setProyecto(e.target.value)}
            style={{ width: '100%', padding: '8px 10px', borderRadius: 8, border: '1px solid #ddd', fontSize: 13 }}>
            <option value="exploradoras">Exploradoras</option>
            <option value="carrileros">UTE Carrileros</option>
          </select>
        </div>
        <div>
          <label style={{ display: 'block', fontSize: 12, color: '#555', marginBottom: 4 }}>Proyecto</label>
          <select value={proyecto} onChange={e => setProyecto(e.target.value)}
            style={{ width: '100%', padding: '8px 10px', borderRadius: 8, border: '1px solid #ddd', fontSize: 13 }}>
            <option value="exploradoras">Exploradoras</option>
            <option value="carrileros">UTE Carrileros</option>
          </select>
        </div>
        {proyecto === 'exploradoras' && (
          <div>
            <label style={{ display: 'block', fontSize: 12, color: '#555', marginBottom: 4 }}>Lote</label>
            <select value={lote} onChange={e => setLote(e.target.value)}
              style={{ width: '100%', padding: '8px 10px', borderRadius: 8, border: '1px solid #ddd', fontSize: 13 }}>
              <option value="lote1">Lote 1</option>
              <option value="lote2">Lote 2</option>
            </select>
          </div>
        )}
        <div>
          <label style={{ display: 'block', fontSize: 12, color: '#555', marginBottom: 4 }}>Locomotora</label>
          <select value={locomotoraId} onChange={e => setLocomotoreId(e.target.value)}
            style={{ width: '100%', padding: '8px 10px', borderRadius: 8, border: '1px solid #ddd', fontSize: 13 }}>
            <option value="">Sin asignar</option>
            {locomotoras.map(l => <option key={l.id} value={l.id}>{l.numero}</option>)}
          </select>
        </div>
      </div>

      <div style={{ marginBottom: 16 }}>
        <label style={{ display: 'block', fontSize: 12, color: '#555', marginBottom: 6 }}>Días de la semana</label>
        <div style={{ display: 'flex', gap: 4 }}>
          {DIAS.map(d => (
            <button key={d.num} onClick={() => toggleDia(d.num)} style={{
              width: 32, height: 32, borderRadius: '50%', border: 'none', cursor: 'pointer', fontSize: 12, fontWeight: 600,
              background: dias.includes(d.num) ? '#1a1a1a' : '#f0f0f0',
              color: dias.includes(d.num) ? '#fff' : '#aaa'
            }}>{d.label}</button>
          ))}
        </div>
      </div>

      <div style={{ marginBottom: 16 }}>
        <label style={{ display: 'block', fontSize: 12, color: '#555', marginBottom: 6 }}>Trenes</label>
        <div style={{ display: 'flex', gap: 8, marginBottom: 10 }}>
          <input value={nuevoTren} onChange={e => setNuevoTren(e.target.value)}
            onKeyDown={e => e.key === 'Enter' && añadirTren()}
            placeholder="Número de tren (ej: 38318)"
            style={{ padding: '8px 10px', borderRadius: 8, border: '1px solid #ddd', fontSize: 13, width: 200 }} />
          <button onClick={añadirTren} disabled={cargandoTren || !nuevoTren}
            style={{ padding: '8px 16px', borderRadius: 8, border: 'none', background: '#1a1a1a', color: '#fff', cursor: 'pointer', fontSize: 13, opacity: cargandoTren ? 0.6 : 1 }}>
            {cargandoTren ? 'Cargando...' : '+ Añadir'}
          </button>
        </div>

        {trenes.length > 0 && (
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 12 }}>
            <thead>
              <tr style={{ background: '#f8f8f6' }}>
                <th style={{ padding: '6px 10px', textAlign: 'left', fontWeight: 500, color: '#555' }}>Nº Tren</th>
                <th style={{ padding: '6px 10px', textAlign: 'left', fontWeight: 500, color: '#555' }}>Salida</th>
                <th style={{ padding: '6px 10px', textAlign: 'left', fontWeight: 500, color: '#555' }}>Origen</th>
                <th style={{ padding: '6px 10px', textAlign: 'left', fontWeight: 500, color: '#555' }}>Llegada</th>
                <th style={{ padding: '6px 10px', textAlign: 'left', fontWeight: 500, color: '#555' }}>Destino</th>
                <th style={{ padding: '6px 10px' }}></th>
              </tr>
            </thead>
            <tbody>
              {trenes.map((t, i) => (
                <tr key={i} style={{ borderTop: '1px solid #f0f0f0' }}>
                  <td style={{ padding: '6px 10px', fontWeight: 600 }}>{t.numero_tren}</td>
                  <td style={{ padding: '6px 10px' }}>{t.hora_inicio}</td>
                  <td style={{ padding: '6px 10px' }}>{t.estacion_inicio}</td>
                  <td style={{ padding: '6px 10px' }}>{t.hora_fin}</td>
                  <td style={{ padding: '6px 10px' }}>{t.estacion_fin}</td>
                  <td style={{ padding: '6px 10px' }}>
                    <button onClick={() => eliminarTren(i)}
                      style={{ padding: '2px 8px', borderRadius: 6, border: '1px solid #ddd', background: '#fff', cursor: 'pointer', fontSize: 11, color: '#e24b4a' }}>
                      ✕
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      {error && <div style={{ background: '#fcebeb', border: '1px solid #e24b4a', borderRadius: 8, padding: '8px 12px', fontSize: 12, color: '#a32d2d', marginBottom: 12 }}>{error}</div>}

      <div style={{ display: 'flex', gap: 8 }}>
        <button onClick={guardar} disabled={guardando || !codigo || trenes.length === 0}
          style={{ padding: '8px 20px', borderRadius: 8, border: 'none', background: '#1a1a1a', color: '#fff', cursor: 'pointer', fontSize: 13, fontWeight: 500, opacity: guardando ? 0.6 : 1 }}>
          {guardando ? 'Guardando...' : 'Guardar servicio'}
        </button>
        <button onClick={onCancelar}
          style={{ padding: '8px 20px', borderRadius: 8, border: '1px solid #ddd', background: '#fff', cursor: 'pointer', fontSize: 13 }}>
          Cancelar
        </button>
      </div>
    </div>
  );
}

export default function ServiciosPredefinidos() {
  const [servicios, setServicios] = useState([]);
  const [locomotoras, setLocomotoras] = useState([]);
  const [loading, setLoading] = useState(true);
  const [expandido, setExpandido] = useState(null);
  const [editandoDias, setEditandoDias] = useState(null);
  const [editandoTren, setEditandoTren] = useState(null);
  const [editandoServicio, setEditandoServicio] = useState(null);
  const [formTren, setFormTren] = useState({});
  const [formServicio, setFormServicio] = useState({});
  const [filtroLote, setFiltroLote] = useState('lote2');
  const [mostrarNuevo, setMostrarNuevo] = useState(false);

  useEffect(() => {
    cargar();
    locomotorasService.getAll().then(r => setLocomotoras(r.data.filter(l => l.activa)));
  }, []);

  const cargar = () => {
    setLoading(true);
    api.get('/servicios-predefinidos/').then(r => setServicios(r.data)).finally(() => setLoading(false));
  };

  const toggleDia = async (servicio, dia) => {
    let dias = servicio.dias_semana || '';
    dias = dias.includes(dia) ? dias.replace(dia, '') : (dias + dia).split('').sort().join('');
    await api.patch(`/servicios-predefinidos/${servicio.id}`, { dias_semana: dias });
    cargar();
  };

  const guardarServicio = async (id) => {
    await api.patch(`/servicios-predefinidos/${id}`, formServicio);
    setEditandoServicio(null);
    setFormServicio({});
    cargar();
  };

  const guardarTren = async () => {
    await api.patch(`/servicios-predefinidos/tren/${editandoTren}`, formTren);
    setEditandoTren(null);
    setFormTren({});
    cargar();
  };

  const eliminarServicio = async (id) => {
    if (!window.confirm('¿Eliminar este servicio?')) return;
    await api.delete(`/servicios-predefinidos/${id}`);
    cargar();
  };

  const filtrados = servicios.filter(s => {
    if (!filtroLote) return true;
    if (filtroLote === 'carrileros') return s.proyecto === 'carrileros';
    return s.lote === filtroLote && (s.proyecto || 'exploradoras') === 'exploradoras';
  });
  if (loading) return <div style={{ padding: 40, color: '#888' }}>Cargando...</div>;

  return (
    <div>
      <div style={{ marginBottom: 24, display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
        <div>
          <h2 style={{ fontSize: 22, fontWeight: 500, margin: 0 }}>Servicios predefinidos</h2>
          <p style={{ fontSize: 13, color: '#888', marginTop: 4 }}>Recorridos fijos con sus trenes asignados</p>
        </div>
        <button onClick={() => setMostrarNuevo(!mostrarNuevo)}
          style={{ padding: '9px 18px', borderRadius: 8, border: 'none', background: '#1a1a1a', color: '#fff', cursor: 'pointer', fontSize: 13, fontWeight: 500 }}>
          {mostrarNuevo ? 'Cancelar' : '+ Nuevo servicio'}
        </button>
      </div>

      {mostrarNuevo && (
        <NuevoServicioForm
          locomotoras={locomotoras}
          onGuardar={() => { setMostrarNuevo(false); cargar(); }}
          onCancelar={() => setMostrarNuevo(false)}
        />
      )}

      <div style={{ display: 'flex', gap: 8, marginBottom: 20, flexWrap: 'wrap' }}>
        {[['', 'Todos'], ['lote1', 'Lote 1'], ['lote2', 'Lote 2'], ['carrileros', 'UTE Carrileros']].map(([val, label]) => (
          <button key={val} onClick={() => setFiltroLote(val)} style={{
            padding: '7px 16px', borderRadius: 8, border: 'none', cursor: 'pointer', fontSize: 13, fontWeight: 500,
            background: filtroLote === val ? '#1a1a1a' : '#f0f0f0',
            color: filtroLote === val ? '#fff' : '#555'
          }}>{label}</button>
        ))}
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
        {filtrados.map(s => (
          <div key={s.id} style={{ background: '#fff', borderRadius: 12, border: '1px solid #e5e5e5', overflow: 'hidden' }}>
            <div style={{ padding: '14px 18px' }}>
              <div style={{ display: 'flex', alignItems: 'flex-start', gap: 12, marginBottom: 10 }}>
                <div style={{ flex: 1, cursor: 'pointer' }} onClick={() => setExpandido(expandido === s.id ? null : s.id)}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
                    <span style={{ fontWeight: 600, fontSize: 15 }}>{s.codigo}</span>
                    <span style={{ fontSize: 11, background: '#f0f0f0', borderRadius: 20, padding: '2px 8px', color: '#555' }}>{s.lote}</span>
                    <span style={{ fontSize: 11, color: '#888' }}>{s.trenes?.length} trenes</span>
                    {s.locomotora_numero && (
                      <span style={{ fontSize: 11, background: '#eaf3de', borderRadius: 20, padding: '2px 8px', color: '#3b6d11' }}>🚂 {s.locomotora_numero}</span>
                    )}
                  </div>
                  {s.trenes?.length > 0 && (
                    <div style={{ fontSize: 12, color: '#888', marginTop: 4 }}>
                      {s.trenes[0].hora_inicio?.substring(0,5)} · {s.trenes[0].estacion_inicio} → {s.trenes[s.trenes.length-1].estacion_fin}
                    </div>
                  )}
                </div>
                <div style={{ display: 'flex', gap: 6, flexShrink: 0 }}>
                  <button onClick={() => { setEditandoServicio(editandoServicio === s.id ? null : s.id); setFormServicio({}); }}
                    style={{ padding: '5px 12px', borderRadius: 8, border: '1px solid #ddd', background: editandoServicio === s.id ? '#1a1a1a' : '#fff', color: editandoServicio === s.id ? '#fff' : '#555', cursor: 'pointer', fontSize: 12 }}>
                    {editandoServicio === s.id ? 'Cancelar' : 'Editar'}
                  </button>
                  <button onClick={() => eliminarServicio(s.id)}
                    style={{ padding: '5px 12px', borderRadius: 8, border: '1px solid #fcc', background: '#fff', cursor: 'pointer', fontSize: 12, color: '#e24b4a' }}>
                    Eliminar
                  </button>
                  <button onClick={() => setExpandido(expandido === s.id ? null : s.id)}
                    style={{ padding: '5px 10px', borderRadius: 8, border: '1px solid #ddd', background: '#fff', cursor: 'pointer', fontSize: 12, color: '#888' }}>
                    {expandido === s.id ? '▲' : '▼'}
                  </button>
                </div>
              </div>

              {editandoServicio === s.id && (
                <div style={{ background: '#f8f8f6', borderRadius: 10, padding: 14, marginBottom: 10 }}>
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 10, marginBottom: 10 }}>
                    <div>
                      <label style={{ display: 'block', fontSize: 11, color: '#555', marginBottom: 4 }}>Código</label>
                      <input value={formServicio.codigo ?? s.codigo} onChange={e => setFormServicio({...formServicio, codigo: e.target.value})}
                        style={{ width: '100%', padding: '7px 10px', borderRadius: 8, border: '1px solid #ddd', fontSize: 13, boxSizing: 'border-box' }} />
                    </div>
                    <div>
                      <label style={{ display: 'block', fontSize: 11, color: '#555', marginBottom: 4 }}>Lote</label>
                      <select value={formServicio.lote ?? s.lote} onChange={e => setFormServicio({...formServicio, lote: e.target.value})}
                        style={{ width: '100%', padding: '7px 10px', borderRadius: 8, border: '1px solid #ddd', fontSize: 13 }}>
                        <option value="lote1">Lote 1</option>
                        <option value="lote2">Lote 2</option>
                      </select>
                    </div>
                    <div>
                      <label style={{ display: 'block', fontSize: 11, color: '#555', marginBottom: 4 }}>Locomotora</label>
                      <select value={formServicio.locomotora_id ?? s.locomotora_id ?? ''}
                        onChange={e => setFormServicio({...formServicio, locomotora_id: parseInt(e.target.value) || null})}
                        style={{ width: '100%', padding: '7px 10px', borderRadius: 8, border: '1px solid #ddd', fontSize: 13 }}>
                        <option value="">Sin asignar</option>
                        {locomotoras.map(l => <option key={l.id} value={l.id}>{l.numero}</option>)}
                      </select>
                    </div>
                  </div>
                  <button onClick={() => guardarServicio(s.id)}
                    style={{ padding: '7px 18px', borderRadius: 8, border: 'none', background: '#1a1a1a', color: '#fff', cursor: 'pointer', fontSize: 13 }}>
                    Guardar cambios
                  </button>
                </div>
              )}

              <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                {editandoDias === s.id ? (
                  <>
                    {DIAS.map(d => (
                      <button key={d.num} onClick={() => toggleDia(s, d.num)} style={{
                        width: 26, height: 26, borderRadius: '50%', border: 'none', cursor: 'pointer', fontSize: 11, fontWeight: 600,
                        background: s.dias_semana?.includes(d.num) ? '#1a1a1a' : '#f0f0f0',
                        color: s.dias_semana?.includes(d.num) ? '#fff' : '#aaa'
                      }}>{d.label}</button>
                    ))}
                    <button onClick={() => setEditandoDias(null)}
                      style={{ padding: '0 10px', height: 26, borderRadius: 6, border: '1px solid #ddd', background: '#fff', cursor: 'pointer', fontSize: 11 }}>✓</button>
                  </>
                ) : (
                  <>
                    <BadgeDias dias={s.dias_semana} />
                    <button onClick={() => setEditandoDias(s.id)}
                      style={{ padding: '2px 8px', borderRadius: 6, border: '1px solid #ddd', background: '#fff', cursor: 'pointer', fontSize: 11, color: '#555' }}>
                      Editar días
                    </button>
                  </>
                )}
              </div>
            </div>

            {expandido === s.id && (
              <div style={{ borderTop: '1px solid #f0f0f0' }}>
                <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
                  <thead>
                    <tr style={{ background: '#f8f8f6' }}>
                      <th style={{ padding: '8px 16px', textAlign: 'left', fontWeight: 500, color: '#555' }}>Nº Tren</th>
                      <th style={{ padding: '8px 16px', textAlign: 'left', fontWeight: 500, color: '#555' }}>H. inicio</th>
                      <th style={{ padding: '8px 16px', textAlign: 'left', fontWeight: 500, color: '#555' }}>Estación inicio</th>
                      <th style={{ padding: '8px 16px', textAlign: 'left', fontWeight: 500, color: '#555' }}>H. fin</th>
                      <th style={{ padding: '8px 16px', textAlign: 'left', fontWeight: 500, color: '#555' }}>Estación fin</th>
                      <th style={{ padding: '8px 16px', textAlign: 'left', fontWeight: 500, color: '#555' }}>KM</th>
                      <th style={{ padding: '8px 16px' }}></th>
                    </tr>
                  </thead>
                  <tbody>
                    {s.trenes.map(t => (
                      <tr key={t.id} style={{ borderTop: '1px solid #f0f0f0' }}>
                        {editandoTren === t.id ? (
                          <>
                            <td style={{ padding: '8px 16px' }}>
                              <input value={formTren.numero_tren ?? t.numero_tren} onChange={e => setFormTren({...formTren, numero_tren: e.target.value})}
                                style={{ width: 80, padding: '4px 8px', borderRadius: 6, border: '1px solid #ddd', fontSize: 13 }} />
                            </td>
                            <td style={{ padding: '8px 16px' }}>
                              <input type="time" value={formTren.hora_inicio ?? t.hora_inicio?.substring(0,5) ?? ''} onChange={e => setFormTren({...formTren, hora_inicio: e.target.value})}
                                style={{ width: 90, padding: '4px 8px', borderRadius: 6, border: '1px solid #ddd', fontSize: 13 }} />
                            </td>
                            <td style={{ padding: '8px 16px', fontSize: 12, color: '#888' }}>{t.estacion_inicio}</td>
                            <td style={{ padding: '8px 16px' }}>
                              <input type="time" value={formTren.hora_fin ?? t.hora_fin?.substring(0,5) ?? ''} onChange={e => setFormTren({...formTren, hora_fin: e.target.value})}
                                style={{ width: 90, padding: '4px 8px', borderRadius: 6, border: '1px solid #ddd', fontSize: 13 }} />
                            </td>
                            <td style={{ padding: '8px 16px', fontSize: 12, color: '#888' }}>{t.estacion_fin}</td>
                            <td style={{ padding: '8px 16px' }}>
                              <input type="number" value={formTren.km_aproximados ?? t.km_aproximados ?? ''} onChange={e => setFormTren({...formTren, km_aproximados: parseFloat(e.target.value)})}
                                style={{ width: 70, padding: '4px 8px', borderRadius: 6, border: '1px solid #ddd', fontSize: 13 }} placeholder="km" />
                            </td>
                            <td style={{ padding: '8px 16px' }}>
                              <div style={{ display: 'flex', gap: 6 }}>
                                <button onClick={guardarTren} style={{ padding: '4px 10px', borderRadius: 6, border: 'none', background: '#1a1a1a', color: '#fff', cursor: 'pointer', fontSize: 12 }}>Guardar</button>
                                <button onClick={() => { setEditandoTren(null); setFormTren({}); }} style={{ padding: '4px 10px', borderRadius: 6, border: '1px solid #ddd', background: '#fff', cursor: 'pointer', fontSize: 12 }}>Cancelar</button>
                              </div>
                            </td>
                          </>
                        ) : (
                          <>
                            <td style={{ padding: '8px 16px', fontWeight: 600 }}>{t.numero_tren}</td>
                            <td style={{ padding: '8px 16px' }}>{t.hora_inicio ? t.hora_inicio.substring(0,5) : '—'}</td>
                            <td style={{ padding: '8px 16px' }}>{t.estacion_inicio}</td>
                            <td style={{ padding: '8px 16px' }}>{t.hora_fin ? t.hora_fin.substring(0,5) : '—'}</td>
                            <td style={{ padding: '8px 16px' }}>{t.estacion_fin}</td>
                            <td style={{ padding: '8px 16px', color: t.km_aproximados ? '#333' : '#aaa' }}>
                              {t.km_aproximados ? `${t.km_aproximados} km` : '—'}
                            </td>
                            <td style={{ padding: '8px 16px' }}>
                              <button onClick={() => { setEditandoTren(t.id); setFormTren({}); }}
                                style={{ padding: '4px 10px', borderRadius: 6, border: '1px solid #ddd', background: '#fff', cursor: 'pointer', fontSize: 12 }}>
                                Editar
                              </button>
                            </td>
                          </>
                        )}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
